import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import {LiveComponentToolsController} from "app/stimulus/live-component-tools-controller";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";

@AsStimulusController('crm-person-detail-internet-banking-credentials-list-item')
export default class extends Typed(LiveComponentToolsController(Controller<HTMLElement>))
{
}
